// Jquery Only for trikot products

$(document).ready(function () { 
     
    if (window.aico_percentage_discount && window.aico_percentage_discount != 0) {
      

    $(".active-product").each(function() {
      const $activeProduct = $(this);

      // Skip if already processed
      if ($activeProduct.hasClass('aico-discount-applied')) {
        return;
      }

      // Add class to mark as processed
      $activeProduct.addClass('aico-discount-applied');

      // Now continue with your logic below
      const main_price_el = $activeProduct.find(".product_trikot_price_wrap .tprice_main .tprice_main_amount");
      let main_price = parseFloat(main_price_el.attr('data-amount'));
      let main_compare_price = parseFloat(main_price_el.attr('data-compare-amount'));
      if (isNaN(main_price)) return; // skip invalid items

      if (!main_compare_price) {


        const discountedPrice = applyAicoDiscount(main_price);
        main_price_el.html(Number(discountedPrice).toFixed(2));

        // if (!window.location.pathname.startsWith('/pages/shop')) {
        
          $activeProduct
            .find(".product_trikot_price_wrap .tprice_main .tprice_main_amount")
            .attr('data-amount', discountedPrice);
        // }

        if (window.location.href.includes('/pages/shop') && $activeProduct.find('.product_trikot_price_wrap').length) {
          if (!$activeProduct.find('.product-form #price_item_discount').length) {
            $activeProduct.find('.product-form').append(
              `<input id="price_item_discount" type="hidden" name="properties[_price_item_discount]" value="${discountedPrice}">`
            );
          }
        }

        
      }
      
      updateTrikotTotal($activeProduct.parent('div'),'onload');
      
    });

    }

    const initSlickSlider = () => {
    $('.section-trikot-product .product__media_wrap').each(function () {
        const $grid = $(this);

        if (!$grid.hasClass('slick-initialized')) {
          $grid.slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            arrows: true,
          });
        }
      });
    };

    const initSlickSliderMobile = () => {
      $('.section-trikot-product .product__mobile_media-list .product__media_wrap').each(function () {
        const $gridMobile = $(this);

        // Only initialize if visible
        if ($gridMobile.is(':visible')) {
          if (!$gridMobile.hasClass('slick-initialized')) {
            $gridMobile.slick({
              dots: false,
              infinite: false,
              speed: 300,
              slidesToShow: 1,
              arrows: true,
            });
          } else {
            $gridMobile.slick('setPosition'); // fix width if already initialized
          }
        }
      });
    };


    // Initialize Slick slider on document ready
    initSlickSlider();
    initSlickSliderMobile();

    // Reinitialize Slick slider on window resize
    $(window).resize(() => {
      initSlickSlider();
      initSlickSliderMobile();
    }); 

  $(document).on('click', '.featured-product .pro__variants_list .pro__variants_single a', function(e) {
      e.preventDefault();
      const $this = $(this);
      $this.parents(".active-product").find('.pro__variants_list .pro__variants_single a').removeClass('active');      
      $this.addClass('active');
      const productHandle = $this.closest('.pro__variants_single').data('handle');    
      get_trikot(productHandle,$this);      
  });

  function get_trikot(productHandle,$this){
    // console.log('Fetching trikot for product handle:', productHandle);
    // console.log('$this',$this)
    // Define the section ID (matches ID in your DOM)
    const sectionId = 'dynamic-trikot-product';
    const url = `/products/${productHandle}?section_id=${sectionId}`;
      fetch(url)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          // console.log('doc',doc);
          const newSection = doc.querySelector(`.section-trikot-product`);
          const media_gallery = newSection.querySelector(`media-gallery`);
          const mobile_media_gallery = newSection.querySelector(`.product__mobile_media-list`); 
          const Innerinfo = newSection.querySelector(`product-info`);        
          if (newSection) {        
            
            // const trikot_section = $this.parents(".active-product.featured-product");
            const trikot_section = $(".active-product.featured-product");
            trikot_section.removeClass(function (index, className) {
              return (className.match(/\btrikot_\S+/g) || []).join(' ');
            });
            
            let dynamic_classname = doc.querySelector(`input[name="trikot_class_name"]`).value;            
            let dynamic_print_font = doc.querySelector(`input[name="trikot_class_name"]`).getAttribute('data-print-font');
            
            trikot_section.addClass(dynamic_classname);
            trikot_section.attr('data-print-font', dynamic_print_font);
            trikot_section.find('media-gallery').replaceWith(media_gallery); 
            trikot_section.find('product-info').replaceWith(Innerinfo);

            initSlickSlider();
            initSlickSliderMobile();
            
          if(typeof customer !== 'undefined'){
              const btn_individual = trikot_section.find('.button_add_individual');
              individual_option(btn_individual);
              if (trikot_section.find('.product__media_wrap').hasClass('slick-initialized')) {                
                trikot_section.find('.product__media_wrap').slick('slickGoTo', 1);
              }
            }
            
            if($('body').hasClass('template-name--team-member-detail')){
              get_player_trikot();
            }

            initVerbandCupBatchAutoSelect(trikot_section);
          }

        })
        .catch(err => console.error('Section render error:', err));
  }

  function initVerbandCupBatchAutoSelect($scope) {
    const $targets = ($scope && $scope.length) ? $scope : $('.active-product');
    $targets.each(function () {
      const $activeProduct = $(this);
      const $badgesTabs = $activeProduct.find('.badges-tabs');
      if (!$badgesTabs.length) return;

      const $weiss = $badgesTabs.find('[data-tab="spielpaarung-weiss"]');
      const $schwarz = $badgesTabs.find('[data-tab="spielpaarung-schwarz"]');
      if (!$weiss.length && !$schwarz.length) return;

      const $verbandCupBatch = $badgesTabs.find('[data-tab="verband-cup-batch"]');

      // Skip if any relevant tab is already active (avoid clobbering an existing selection)
      if ($verbandCupBatch.hasClass('active') || $weiss.hasClass('active') || $schwarz.hasClass('active')) return;

      let $firstSpielpaarung;
      if ($weiss.length && $schwarz.length) {
        $firstSpielpaarung = ($weiss.index() < $schwarz.index()) ? $weiss : $schwarz;
      } else {
        $firstSpielpaarung = $weiss.length ? $weiss : $schwarz;
      }
      $firstSpielpaarung.trigger('click');
    });
  }

  $(document).on('click','.trikots-tabs:not(.badges-tabs) .tab',function(){
    const $this = $(this);
    const $activeProduct = $(this).closest(".active-product");      
    $activeProduct.find(".trikots-tabs:not(.badges-tabs) .tab").removeClass("active"); 
    $(this).addClass("active");
    let tabValue = $(this).attr("data-tab");
    let pro_type = 'Flock';

    // Display delivery not based on badge type
    let active_badge_tab = $activeProduct.find('.trikots-tabs.badges-tabs .tab.active').attr("data-tab");
    var flag = 0;
    if(tabValue != 'Ohne'){
      flag++;
    }
    if(active_badge_tab != 'Ohne Badge' && typeof active_badge_tab != 'undefined'){
      flag++;
    }
    
    /*if(flag == 0){
      $activeProduct.find('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.normal_product').removeClass('hidden');
      $activeProduct.find('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.trikot_product').addClass('hidden');
    }else{
      $activeProduct.find('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.normal_product').addClass('hidden');
      $activeProduct.find('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.trikot_product').removeClass('hidden');
    }*/

    if(flag == 0){
      $activeProduct.find('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.normal_product').removeClass('hidden');
      $activeProduct.find('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.trikot_product').addClass('hidden');
      $activeProduct.find('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.tag_trikot_product').addClass('hidden');
    }else{      
      if($('[data-tab="alles-oder-nichts"]').hasClass('active')){
        $activeProduct.find('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.normal_product').addClass('hidden');
        $activeProduct.find('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.trikot_product').addClass('hidden');
        $activeProduct.find('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.tag_trikot_product').removeClass('hidden');
      }else{
        $activeProduct.find('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.normal_product').addClass('hidden');
        $activeProduct.find('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.tag_trikot_product').addClass('hidden');
        $activeProduct.find('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.trikot_product').removeClass('hidden');
      }
    }
    
    let closestProductInfo = $(this).closest('product-info');
    let product_form__error_message_wrapper = $(closestProductInfo).find('.product-form__error-message-wrapper');
    let product_form__error_message = $(closestProductInfo).find('.product-form__error-message');
    product_form__error_message_wrapper.attr("hidden",true);
    product_form__error_message.text('');   
    
    $activeProduct.find(".trikots-contents:not(.badges-contents) .hidden_product_input").removeClass("active"); 
    $activeProduct.find('.trikots-contents .hidden_product_input[data-content="' + tabValue + '"]').addClass("active"); // Show the matching content    
    
    if(tabValue == 'spieler' || tabValue == 'individuell'){      
       $activeProduct.find(".product__media-list").each(function() {
          const $mediaItems = $(this).find(".product__media-item");
          const $mediaItems_spieler = $mediaItems.eq(1).find(".pro_spieler_main");          
          if ($mediaItems.eq(1).length) {
            $mediaItems.removeClass("is-active");
            $mediaItems.eq(1).addClass("is-active");
          }
       });      
       if($activeProduct.find('.product__media_wrap').hasClass('slick-initialized')) {
         $activeProduct.find('.product__media_wrap').slick('slickGoTo', 1);
       }

      if($('.trikot-product .mainProduct-wrapper .product__media-wrapper .slider').hasClass('slick-initialized')) {
         $('.trikot-product .mainProduct-wrapper .product__media-wrapper .slider').slick('slickGoTo', 1);
       }

      if(tabValue == 'individuell' && typeof customer !== 'undefined' && (!$('body').hasClass('template-name--team-member-detail'))){
        let birthdate = customer.birthdate || '01.01.1979';
        let year = Number(birthdate.split(".")[2]);
        let isBetween2000and2009 = year >= 2000 && year <= 2009;
        let last_name = customer.last_name || '';
        let birthyear = birthdate.slice(-2);
        if(isBetween2000and2009){
          birthyear = 79;
        }        

        $activeProduct.find('#individuell_modal .individuell-nummer-text').val(birthyear);
        $activeProduct.find('#individuell_modal .individual_list li').removeClass('active');
        $activeProduct.find('#individuell_modal .individual_list li[data-val="'+birthyear+'"]').addClass('active');
        $activeProduct.find('#individuell_modal .individuell-name').val(last_name);
      }
     
      if((tabValue == 'spieler') && ($('body').hasClass('template-name--team-member-detail'))){
        get_player_trikot();  
      }
    }
    else {
       const secondImage =  $activeProduct.find('.product__media-list .product__media-item').eq(1).find('img').attr('data-zoom-image'); 
       $activeProduct.find('.product__media-list .product__media-item').eq(1).find('img').attr('src',secondImage);
       const MobileSecondImage = $activeProduct.find('.product__mobile_media-list .product__media-item').eq(1).find('img').attr('data-zoom-image'); 
       $activeProduct.find('.product__mobile_media-list .product__media-item').eq(1).find('img').attr('src',MobileSecondImage);
      
       $activeProduct.find(".product__media-list").each(function() {
          $(this).find(".product__media-item").removeClass("is-active"); 
          $(this).find(".product__media-item").eq(0).addClass("is-active");
       });       
       if ($activeProduct.find('.product__media_wrap').hasClass('slick-initialized')) {
         $activeProduct.find('.product__media_wrap').slick('slickGoTo', 0);
       }
      if($('.trikot-product .mainProduct-wrapper .product__media-wrapper .slider').hasClass('slick-initialized')) {
        $('.trikot-product .mainProduct-wrapper .product__media-wrapper .slider').slick('slickGoTo', 0);
      }

       $activeProduct.find('.individuell-nummer').val('');
       $activeProduct.find(".individuell-name").val('');
       $activeProduct.find('.individuell-nummer-text').val('');
       $activeProduct.find(".individuell-name-text").val('');
       $activeProduct.find('.individual_options .individual_list li').removeClass('active');
       $activeProduct.find(".hidden_product_input[data-content='individuell'] input[type='checkbox']").prop("checked", false);
       $activeProduct.find(".hidden_product_input[data-content='individuell-name'] input[type='checkbox']").prop("checked", false);
      

       $activeProduct.find(".pro_spieler_name").text('');
       $activeProduct.find(".pro_spieler_no").text('');
       $activeProduct.find('.spieler-nummer').val('');
       $activeProduct.find(".spieler-name").val('');
       $activeProduct.find('.custom-dropdown-main-wrap .custom-dropdown-list li').removeClass('active');
       $activeProduct.find('.hidden_product_input[data-content="spieler"] .select__select').val('0').change();
       $activeProduct.find('.product-form .properties_flock').val('');
      
       const type_price_item = $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-type='${pro_type}']`);
       type_price_item.removeClass('active');
       type_price_item.attr('data-amount','');
       type_price_item.text('');
    }

    updateTrikotTotal($this);
    
  });

  let activeBadges = [];
  $(document).off('click.badges').on('click.badges', '.badges-tabs .tab', function () {
    const $this = $(this);
    if ($this.hasClass('disabled')) return;
    const $activeProduct = $this.closest(".active-product");

    let tabValue = $this.attr("data-tab");
    let tabName = $this.attr("data-name");
    let pro_type = 'Badge';

    if(tabName){

      $activeProduct.find(".badges-tabs .tab[data-tab='Ohne Badge']").removeClass("active");
      if(!$this.hasClass('disabled')){
        $(this).toggleClass("active");
      }

      const badge_product = $activeProduct.find(".badges-contents .hidden_product_input[data-content='"+ tabValue +"'] input[type='checkbox']");      
      badge_product.prop("checked", function(i, val) {
          return !val;
      });      

      const price = badge_product.attr('data-price');
      let amount = badge_product.attr('data-amount');
      const pro_tag = badge_product.attr('data-tag');   
      const pro_content = badge_product.attr('data-content');      
      if(price && pro_content){
         const selected_price_item = $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-handle='${pro_content}']`);
         if($(this).hasClass("active")) {             
             // data-amount keeps the undiscounted price; updateTrikotTotal applies the customer discount once
             selected_price_item.text(" + CHF "+amount);           
             selected_price_item.attr('data-type',pro_type);             
             selected_price_item.attr('data-amount',amount);
             selected_price_item.addClass('active');
             if (!activeBadges.includes(tabName)) {
                activeBadges.push(tabName);
             }
          }
          else {
             selected_price_item.text('');
             selected_price_item.attr('data-type','');
             selected_price_item.attr('data-amount','');
             selected_price_item.removeClass('active');
             activeBadges = activeBadges.filter(item => item !== tabName);
          } 
        } 
        
        $activeProduct.find('.product-form .properties_badges').val(activeBadges.join(', '));             
        if(activeBadges.length == 0){
          $activeProduct.find(".badges-tabs .tab[data-tab='Ohne Badge']").addClass("active");
        }
      }
      else {
        
        $activeProduct.find(".badges-tabs .tab").removeClass("active"); 
        $(this).addClass("active");
        activeBadges = [];
        $activeProduct.find('.product-form .properties_badges').val('');
        $activeProduct.find(".badges-contents .hidden_product_input input[type='checkbox']").prop("checked", false);
        
        const type_price_item = $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-type='${pro_type}']`);
        type_price_item.text('');
        type_price_item.attr('data-amount','');
        type_price_item.removeClass('active'); 
      }

    // Display delivery not based on badge type
    let active_trikot_tab = $activeProduct.find(".trikots-tabs:not(.badges-tabs) .tab.active").attr("data-tab");
    var flag = 0;
    if(tabName != 'Ohne Badge' && activeBadges.length > 0){
      flag++
    }
    if(active_trikot_tab != 'Ohne'){
      flag++
    }
    
    /*if(flag == 0){
      $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.normal_product').removeClass('hidden');
      $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.trikot_product').addClass('hidden');
    }else{
      $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.normal_product').addClass('hidden');
      $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.trikot_product').removeClass('hidden');
    }*/
    
    if(flag == 0){
      $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.normal_product').removeClass('hidden');
      $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.trikot_product').addClass('hidden');
      $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.tag_trikot_product').addClass('hidden');
    }else{      
      if($('[data-tab="alles-oder-nichts"]').hasClass('active')){
        $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.normal_product').addClass('hidden');
        $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.trikot_product').addClass('hidden');
        $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.tag_trikot_product').removeClass('hidden');
      }else{
        $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.normal_product').addClass('hidden');
        $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.tag_trikot_product').addClass('hidden');
        $(this).parents('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.trikot_product').removeClass('hidden');
      }
    }

    if(tabValue == 'brack-super-league' && $this.hasClass('active')){
      $('.badges-tabs [data-tab="alles-oder-nichts"]').addClass('disabled');
    }
    if(tabValue == 'brack-super-league' && !$this.hasClass('active')){
      $('.badges-tabs [data-tab="alles-oder-nichts"]').removeClass('disabled');
    }

    if(tabValue == 'alles-oder-nichts' && $this.hasClass('active')){
      $('.badges-tabs [data-tab="brack-super-league"]').addClass('disabled');
    }
    if(tabValue == 'alles-oder-nichts' && !$this.hasClass('active')){
      $('.badges-tabs [data-tab="brack-super-league"]').removeClass('disabled');
    }

    // Verband Cup Batch + Spielpaarung weiss/schwarz interaction
    const $verbandCupBatch = $activeProduct.find('.badges-tabs [data-tab="verband-cup-batch"]');
    const $spielpaarungWeiss = $activeProduct.find('.badges-tabs [data-tab="spielpaarung-weiss"]');
    const $spielpaarungSchwarz = $activeProduct.find('.badges-tabs [data-tab="spielpaarung-schwarz"]');

    if(tabValue == 'Ohne Badge'){
      $('.badges-tabs [data-tab="alles-oder-nichts"]').removeClass('disabled');
      $('.badges-tabs [data-tab="brack-super-league"]').removeClass('disabled');
      $spielpaarungWeiss.removeClass('disabled');
      $spielpaarungSchwarz.removeClass('disabled');
    }

    // Mutual exclusion between Spielpaarung weiss and Spielpaarung schwarz:
    // selecting one deselects the other; either selection auto-selects Verband Cup Batch.
    if (tabValue === 'spielpaarung-weiss' || tabValue === 'spielpaarung-schwarz') {
      if ($this.hasClass('active')) {
        const $other = (tabValue === 'spielpaarung-weiss') ? $spielpaarungSchwarz : $spielpaarungWeiss;
        if ($other.hasClass('active')) {
          $other.trigger('click');
        }
        if ($verbandCupBatch.length && !$verbandCupBatch.hasClass('active')) {
          $verbandCupBatch.trigger('click');
        }
      } else {
        // Genuine deselect (not a swap): if no Spielpaarung remains active, deselect Verband Cup Batch too
        if (!$spielpaarungWeiss.hasClass('active') && !$spielpaarungSchwarz.hasClass('active') && $verbandCupBatch.hasClass('active')) {
          $verbandCupBatch.trigger('click');
          const cascadeMsg = 'Die beiden Badges sind nur zusammen verfügbar.';
          const $errorWrapper = $activeProduct.find('.product-form__error-message-wrapper');
          const $errorMsg = $activeProduct.find('.product-form__error-message');
          $errorWrapper.removeAttr('hidden');
          $errorMsg.text(cascadeMsg);
          setTimeout(function () {
            if ($errorMsg.text() === cascadeMsg) {
              $errorWrapper.attr('hidden', true);
              $errorMsg.text('');
            }
          }, 5000);
        }
      }
    }

    if (tabValue === 'verband-cup-batch') {
      if ($this.hasClass('active')) {
        // Auto-select first available Spielpaarung if none is active
        if (!$spielpaarungWeiss.hasClass('active') && !$spielpaarungSchwarz.hasClass('active')) {
          let $firstSpielpaarung;
          if ($spielpaarungWeiss.length && $spielpaarungSchwarz.length) {
            $firstSpielpaarung = ($spielpaarungWeiss.index() < $spielpaarungSchwarz.index()) ? $spielpaarungWeiss : $spielpaarungSchwarz;
          } else if ($spielpaarungWeiss.length) {
            $firstSpielpaarung = $spielpaarungWeiss;
          } else if ($spielpaarungSchwarz.length) {
            $firstSpielpaarung = $spielpaarungSchwarz;
          }
          if ($firstSpielpaarung && $firstSpielpaarung.length) {
            $firstSpielpaarung.trigger('click');
          }
        }
      } else {
        if ($spielpaarungWeiss.hasClass('active')) {
          $spielpaarungWeiss.trigger('click');
        }
        if ($spielpaarungSchwarz.hasClass('active')) {
          $spielpaarungSchwarz.trigger('click');
        }
      }
    }

    updateTrikotTotal($this);

  });

  $(document).on("change keyup focusout",".individuell-nummer", function () {
    var $this = $(this);
    var n = $(this).val();

    if (n < 0) {
      $this.parents(".active-product").find(".individuell-nummer").val(0);
    } else if (n > 99) {
      $this.parents(".active-product").find(".individuell-nummer").val(99);
    }
    $this.next('span').find('span').text($(this).val().length)

    $this.parents(".active-product").find(".pro_spieler_no").text(n);
  });

  $(document).on("change keyup focusout",".individuell-name", function () {
    let $this = $(this);
    let txtInput = $(this).val();
    let txtInput_lower = txtInput.toLowerCase();

    let badWord = "fuck";
    if (txtInput_lower.indexOf(badWord) != -1) {
      let txtInputnew = txtInput_lower.replace(badWord, "");
      $this.parents(".active-product").find(".individuell-name").val(txtInputnew);
      $this.parents(".active-product").find(".pro_spieler_name").text(txtInputnew);
      $this.next('span').find('span').text(txtInputnew.length);
    } else {
      $this.parents(".active-product").find(".individuell-name").val(txtInput);
      $this.parents(".active-product").find(".pro_spieler_name").text(txtInput);
      $this.next('span').find('span').text(txtInput.length)
    }
  });

  $(document).on('click','.active-product .custom-dropdown-main-wrap .custom-dropdown-selected-wrap', function(){
      $(this).parent().toggleClass('active');
  });

  $(document).on('click','.custom-dropdown-main-wrap .custom-dropdown-list li', function(){
    spilier_option($(this));
  });
  
  $(document).on('change','.product-form__input--dropdown .select select', function(){
    const $activeProduct = $(this).closest(".active-product");
    var name = $(this).attr("name");
    var index = $(this).attr("option-index");
    var price = $("option:selected", this).attr("data-price");
    var $this = $(this);
    
    var value = $(this).val();
    if (value && value != 0) {
      var arr = [];
      var name = [];
      arr = value.split(" - ");
      if (arr.length > 1 && arr[1]) {
        name = arr[1].split(" ");
      } else {
        name = [];
      }
      // name = arr[1].split(" ");

      // var s_no = value.slice(value.indexOf('[') +1,value.indexOf(']'));
      // var s_name = value.replace(/ *\[[^\]]*]/, '');
      // $this.parents(".active-product").find(".pro_spieler_no").text(arr[0]);
      // $this.parents(".active-product").find(".pro_spieler_name").text(arr[1].slice(0,14));

      $activeProduct.find('.individuell-nummer').val('');
      $activeProduct.find(".individuell-name").val('');
      $activeProduct.find('.individuell-nummer-text').val('');
      $activeProduct.find(".individuell-name-text").val('');
      $activeProduct.find(".hidden_product_input[data-content='individuell'] input[type='checkbox']").prop("checked", false);
      $activeProduct.find(".hidden_product_input[data-content='individuell-name'] input[type='checkbox']").prop("checked", false);
      $activeProduct.find('.product-form .properties_flock').val(value);
    }

    let closestProductInfo = $(this).closest('product-info');
    let product_form__error_message_wrapper = $(closestProductInfo).find('.product-form__error-message-wrapper');
    let product_form__error_message = $(closestProductInfo).find('.product-form__error-message');
    product_form__error_message_wrapper.attr("hidden",true);
    product_form__error_message.text('');
    
  });

  if(typeof customer !== 'undefined' && (!$('body').hasClass('template-name--team-member-detail'))){
    $('.active-product').each(function () {
      const $activeProduct = $(this);
      const $this = $activeProduct.find('.button_add_individual');
      
      individual_option($this);

      if ($activeProduct.find('.product__media_wrap').hasClass('slick-initialized')) {
        $activeProduct.find('.product__media_wrap').slick('slickGoTo', 1);
      }
    });
   
    if($('.trikot-product .mainProduct-wrapper .product__media-wrapper .slider').hasClass('slick-initialized')) {
      $('.trikot-product .mainProduct-wrapper .product__media-wrapper .slider').slick('slickGoTo', 1);
    }
  }

  if($('body').hasClass('template-name--team-member-detail')){
    get_player_trikot();
  }
  // get player details on player details page section
  function get_player_trikot(){
    
    subscribe("player-news-loaded", function(response_data){
      if(response_data.length > 0){
        let attributes = response_data[0].attributes,
          last_name = attributes.lastName,
          jerseyNo = 79;

        var is_staff = attributes.crmTags.some(function (crmTags) {
          return crmTags.name === "Staff";
        });
        if(!is_staff){
          $('.section-trikot-product .gradient').removeClass('hidden');
          $('.section-trikot-product').removeClass('hidden');
        }else{
          $('.section-trikot-product').addClass('hidden');
        }

        for(var c=0; c<attributes.customFields.length; c++){        
          if(attributes.customFields[c].locale == 'de_CH'){ 
            if(attributes.customFields[c].name == 'Trikotnummer'){
              if(attributes.customFields[c].value){
                jerseyNo = attributes.customFields[c].value;
              }                
            }
          }
        }

        let customerProducts = attributes.customerProducts || '',
            trikot_product_handle = '';
        let trikot_product;
        if(customerProducts != ''){
          if(customerProducts.length > 0){
            trikot_product_handle = customerProducts[0].urlHandle || '';
          }
        }

        window.player = {
          jersey_number:jerseyNo,
          last_name:last_name
        }

        var isWoman = attributes.customerGroups.some(function (customerGroups) {
          return customerGroups.name === "Frauen";
        });

        if(isWoman && trikot_product_handle == ''){
          trikot_product_handle = 'product-706';
        }

        if($('.active-product .custom-dropdown-main-wrap .custom-dropdown-list li[data-index="'+jerseyNo+'"]').length > 0 && !isWoman){
          $(".active-product .trikots-tabs:not(.badges-tabs) .tab").removeClass("active"); 
          $('.active-product .trikots-tabs [data-tab="spieler"]').addClass('active');
          $('.active-product .trikots-contents .product-form__input').removeClass('active');
          $('.active-product .trikots-contents [data-content="spieler"]').addClass('active');
          $(".active-product").find('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.normal_product').addClass('hidden');
          $(".active-product").find('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.trikot_product').removeClass('hidden');
          
          $(".active-product").find('#spieler-nummer').val('');
          $(".active-product").find('#spieler-name').val('');
      
          $(".active-product").find('#spieler-nummer').val(jerseyNo);
          $(".active-product").find('#spieler-name').val(last_name);
          $('.active-product .custom-dropdown-main-wrap .custom-dropdown-list li[data-index="'+jerseyNo+'"]').addClass('active');
          
          let $this =  $('.active-product .custom-dropdown-main-wrap .custom-dropdown-list li[data-index="'+jerseyNo+'"].active');
          spilier_option($this)
          
          if ($('.section-trikot-product .product__media_wrap').hasClass('slick-initialized')) {
           $('.section-trikot-product .product__media_wrap').slick('slickGoTo', 1);
          }
        }
        if(trikot_product_handle != ''){
          // console.log('trikot_product_handle', trikot_product_handle);
          if(trikot_product_handle == 'goalietrikot-heim-2526'){
            trikot_product_handle = 'product-705';
          }
          get_trikot(trikot_product_handle, $('.active-product .custom-dropdown-main-wrap .custom-dropdown-list li[data-index="'+jerseyNo+'"].active'));
        }
      }
    });
    if(typeof player !== 'undefined'){
      
      if($('.active-product .custom-dropdown-main-wrap .custom-dropdown-list li[data-index="'+player.jersey_number+'"]').length > 0){
        $(".active-product .trikots-tabs:not(.badges-tabs) .tab").removeClass("active"); 
        $('.active-product .trikots-tabs [data-tab="spieler"]').addClass('active');
        $('.active-product .trikots-contents .product-form__input').removeClass('active');
      
        $('.active-product .trikots-contents [data-content="spieler"]').addClass('active');
      
        $(".active-product").find('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.normal_product').addClass('hidden');
        $(".active-product").find('.product__info-wrapper').find('.stock_wrap').children('.delivery_note.trikot_product').removeClass('hidden');
        
        $(".active-product").find('#spieler-nummer').val('');
        $(".active-product").find('#spieler-name').val('');
    
        $(".active-product").find('#spieler-nummer').val(player.jersey_number);
        $(".active-product").find('#spieler-name').val(player.last_name);
        $('.active-product .custom-dropdown-main-wrap .custom-dropdown-list li[data-index="'+player.jersey_number+'"]').addClass('active');
        
        let $this =  $('.active-product .custom-dropdown-main-wrap .custom-dropdown-list li[data-index="'+player.jersey_number+'"].active');
        spilier_option($this)
        
        if ($('.section-trikot-product .product__media_wrap').hasClass('slick-initialized')) {
         $('.section-trikot-product .product__media_wrap').slick('slickGoTo', 1);
        }
      }
    }
  }

  $(document).on('click','.button_add_individual',function(){
    individual_option($(this));
  });

  function spilier_option($this){    
   const $activeProduct = $this.closest(".active-product");
   $activeProduct.find('.custom-dropdown-main-wrap .custom-dropdown-list li').removeClass('active');
   $this.addClass('active');
   let price = $this.attr('data-price');
   // data-amount keeps the undiscounted price; updateTrikotTotal applies the customer discount once
   let amount = $this.attr('data-amount');
   
   price = " + CHF "+amount;   
   
   const pro_tag = $this.parent().attr('data-tag');
   const pro_type = $this.parent().attr('data-type');
   if(price && pro_tag){
     const type_price_item =  $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item.active[data-type='${pro_type}']`);
     if(type_price_item.length > 0){
       type_price_item.text('');
       type_price_item.attr('data-type','');
       type_price_item.attr('data-amount','');
       type_price_item.removeClass('active');
     }
     const selected_price_item =  $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-handle='${pro_tag}']`);
     selected_price_item.text(price);
     selected_price_item.attr('data-type',pro_type);
     selected_price_item.attr('data-amount',amount);
     selected_price_item.addClass('active');
     updateTrikotTotal($this);
   }
   $(settings.objModalCloseBtn).trigger('click');

   let txtInput = $this.attr('data-val');
   if (txtInput) {
      // Split the string by hyphens
      let parts = txtInput.split('-');
      let spieler_nummer = '';
      let spieler_name = '';
     
      if(parts[0]){
        spieler_nummer = parts[0];
        $activeProduct.find(".spieler-nummer").val(spieler_nummer);
      }
      if(parts[1]){
        spieler_name = parts.slice(1).join('-').trim();
        $activeProduct.find(".spieler-name").val(spieler_name);
      }

      const canvasId = $activeProduct.find('#canvas-wrapper canvas').attr('id'); 
      const secondImage = $activeProduct.find('.product__media-list .product__media-item').eq(1).find('img').attr('data-zoom-image'); 
      const secondImageSelector = $activeProduct.find('.product__media-list .product__media-item').eq(1).find('img');
      const MobileImageSelector = $activeProduct.find('.product__mobile_media-list .product__media-item').eq(1).find('img');
         
      if(canvasId){
        renderTshirtPreview({
          canvasId: canvasId,
          imageUrl: secondImage,
          playerName: spieler_name,
          playerNumber: spieler_nummer,
          injectIntoSelector: secondImageSelector,
          options: {
            numberOffsetX: 0 // keep number aligned with the name on canvas center
          }
        });
        renderTshirtPreview({
          canvasId: canvasId,
          imageUrl: secondImage,
          playerName: spieler_name,
          playerNumber: spieler_nummer,
          injectIntoSelector: MobileImageSelector,
          options: {
            numberOffsetX: 0 // keep number aligned with the name on canvas center
          }
        });
      }          
   }     

   const $select = $activeProduct.find('.hidden_product_input[data-content="spieler"] select.select__select');    
    if ($select.find(`option[value="${txtInput}"]`).length) {
      $select.val(txtInput).trigger('change');
    }
  }

  function individual_option($this){
    const $activeProduct = $this.closest(".active-product");    
    let no = $activeProduct.find('#individuell-nummer-text').val();
    let name = $activeProduct.find("#individuell-name-text").val();

    let flag = 0;

    if(no == '' && name == ''){
      flag++;
    }    
    
    if(flag == 0){
      $this.siblings('.error_wrapper').find('.error').text('');
      $activeProduct.find('#individuell-nummer').val(no);
      $activeProduct.find('#individuell-name').val(name);
      $activeProduct.find(".pro_spieler_name").text(name);
      $activeProduct.find(".pro_spieler_no").text(no);
      
      $activeProduct.find('.product-form .properties_flock').val(""+no+" "+name+""); 
      const individuell_no_checkbox = $activeProduct.find(".hidden_product_input[data-content='individuell'] input[type='checkbox']");
      individuell_no_checkbox.prop("checked", false);
      const individuell_name_checkbox = $activeProduct.find(".hidden_product_input[data-content='individuell-name'] input[type='checkbox']");
      individuell_name_checkbox.prop("checked", false);
      var individuell_no_checked = '';
      
      if($activeProduct.find('.modalWrapper .individual_options').length > 0 ){        
        let var_id = $activeProduct.find('.modalWrapper .individual_options').find('.individual_list li.active').data('variantid');
        if(no){          
           individuell_no_checked = $activeProduct.find(".hidden_product_input[data-content='individuell'] input[type='checkbox'][data-variantid='" + var_id + "']");
           individuell_no_checked.prop("checked", true);
        }
        if(individuell_name_checkbox.length && name){
          individuell_name_checkbox.prop("checked", true);
        }
      }
      else {           
        if(typeof customer === 'undefined'){
          if(no){
            individuell_no_checkbox.prop("checked", true);
            individuell_no_checked = individuell_no_checkbox;
          }
        }
        if(individuell_name_checkbox.length && name){
          individuell_name_checkbox.prop("checked", true);          
        }      
      }
     
      $activeProduct.find('.spieler-nummer').val('');
      $activeProduct.find(".spieler-name").val('');
      $activeProduct.find('.custom-dropdown-main-wrap .custom-dropdown-list li').removeClass('active'); 
      $activeProduct.find(".product-form__input--dropdown[data-content='spieler'] .select__select").val("0").trigger("change");
      $(settings.objModalCloseBtn).trigger('click');           
       
     const type_price_item =  $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item.active[data-type='Flock']`);
     if(type_price_item.length > 0){
       type_price_item.text('');
       type_price_item.attr('data-type','');
       type_price_item.attr('data-amount','');
       type_price_item.removeClass('active');
     }

      applyIndividuellPrice(individuell_name_checkbox, $activeProduct);
      applyIndividuellPrice(individuell_no_checked, $activeProduct);
      updateTrikotTotal($this);       

       const canvasId = $activeProduct.find('#canvas-wrapper canvas').attr('id'); 
       const secondImage = $activeProduct.find('.product__media-list .product__media-item').eq(1).find('img').attr('data-zoom-image'); 
       const secondImageSelector = $activeProduct.find('.product__media-list .product__media-item').eq(1).find('img');
       const MobileImageSelector = $activeProduct.find('.product__mobile_media-list .product__media-item').eq(1).find('img');
       if(canvasId){
        renderTshirtPreview({
          canvasId: canvasId,
          imageUrl: secondImage,
          playerName: name,
          playerNumber: no,
          injectIntoSelector: secondImageSelector,
           options: {
            numberOffsetX: 0 // adjust manually for mobile if needed
          }
        });
        renderTshirtPreview({
          canvasId: canvasId,
          imageUrl: secondImage,
          playerName: name,
          playerNumber: no,
          injectIntoSelector: MobileImageSelector,
          options: {
            numberOffsetX: 0 // adjust manually for mobile if needed
          }
        });
       }      
    }
    else{      
      $this.siblings('.error_wrapper').find('.error').text('Nummer oder Name werden benötigt');
    }
  } 

  $(document).on('click','.button--personalisieren',function(){
      const $activeProduct = $(this).closest(".active-product");
      $activeProduct.find('.product__info-wrapper.grid__item').addClass("active");
      $activeProduct.find('.grid__item.product__media-wrapper').addClass("active");
      setTimeout(() => {
        initSlickSliderMobile();
      }, 100);
  });    

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {        
      const sectionId = event?.data?.sectionId;
      if (!sectionId) return;
      
      //  alert('v');
    const $this = $(`product-info[data-section="${sectionId}"]`);
    
   updateTrikotTotal($this);
  });

  function applyIndividuellPrice(checkboxEl, $activeProduct) {
    if(!checkboxEl){
      return false;
    }    
    if (checkboxEl.prop("checked")) {
      
      const pro_tag = checkboxEl.attr("data-tag");
      const pro_type = checkboxEl.attr("data-type");
      const pro_price = checkboxEl.attr("data-price");
      // data-amount keeps the undiscounted price; updateTrikotTotal applies the customer discount once
      const pro_amount = checkboxEl.attr("data-amount");
  
      const selected_price_item = $activeProduct.find(
        `.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-handle='${pro_tag}']`
      );      
      selected_price_item.text(pro_price);
      selected_price_item.attr("data-type", pro_type);
      selected_price_item.attr("data-amount", pro_amount);
      selected_price_item.addClass("active");
    }
  }

  function updateTrikotTotal($this,$type=null){  
    
     let $activeProduct = $this.closest(".active-product");
     if($activeProduct.length == 0) {
        $activeProduct = $this.find(".active-product");
     }

     const main_price_el = $activeProduct.find(".product_trikot_price_wrap .tprice_main .tprice_main_amount");
     if (main_price_el.length === 0) return;

     var main_price = parseFloat(main_price_el.attr('data-amount'));
     if (isNaN(main_price)) return;
     let total_main_amount = 0;
     var main_compare_price = parseFloat(main_price_el.attr('data-compare-amount'));
     if(window.aico_percentage_discount && window.aico_percentage_discount!=0 && main_compare_price){
        main_price = parseFloat(main_price_el.attr('data-main-amount'));
        main_price = applyAicoDiscount(main_price);
     }
    
     const active_price = $activeProduct.find(".product__buy-button-wrap").first().find(".tprice_extra_wrap .hidden-price-item.active");          
     if(active_price.length > 0){
       $activeProduct.find(".product_trikot_price_wrap .gross_price_wrap").removeClass('hide_total');       
     }
     else {
       $activeProduct.find(".product_trikot_price_wrap .gross_price_wrap").addClass('hide_total');
     }    
     
     let total_amount = parseFloat(main_price); 
     active_price.each(function() {
     const pro_content = $(this).data('handle');
     const selected_price_item = $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-handle='${pro_content}']`);
     // Use data-amount if set (actual price, e.g., 0.00 for free badges), otherwise fall back to data-main-amount
     // .attr(), not .data(): jQuery caches .data() on first read and would miss later attribute updates
     var dataAmount = $(this).attr('data-amount');
     var amount = (dataAmount !== '' && dataAmount !== undefined && !isNaN(parseFloat(dataAmount)))
                  ? parseFloat(dataAmount)
                  : parseFloat($(this).data('main-amount'));
     var main_amount = parseFloat($(this).data('main-amount'));
     if (!isNaN(amount)) {           
        if (window.aico_percentage_discount && window.aico_percentage_discount != 0) {
          amount = applyAicoDiscount(amount);
          amount = Number(amount);
          selected_price_item.text(" + CHF " + amount.toFixed(2));
          selected_price_item.addClass('active');
        }
        total_amount += amount;
        total_main_amount +=main_amount;
      }
    });    
    total_amount = total_amount.toFixed(2);    
    const total_amount_currency = `${Currency} ${total_amount}`;
    $activeProduct.find(".product_trikot_price_wrap .gross_price_wrap .tprice_total_amount").text(total_amount);    
    
    const HasDiscountPrice = $activeProduct.find('.af-price .af-discount-price');
    waitForDiscountPrice(
      $activeProduct,
      function($HasDiscountPrice) {
        // ✅ Discount price exists
        // This product's own original price (the attribute follows variant changes; .data() would not)
        const total_main_amount_formatted = parseFloat($activeProduct.find('.tp_og_amount').first().attr('data-og-amount')) + total_main_amount;
        const total_main_amount_currency = `${Currency} ${total_main_amount_formatted.toFixed(2)}`;
        
        // The phone price shows the same total as the desktop one (task 140580)
        $activeProduct.find('.product__info-container .price .af-strike-price, .mobile_price_title_wrapper .price .af-strike-price').text(total_main_amount_currency);
        $activeProduct.find('.product__info-wrapper .af-discount-price-inner, .mobile_price_title_wrapper .af-discount-price-inner').text(total_amount_currency);
      },
      function() {
        // ❌ Discount price not found → fallback
        $activeProduct.find(".price .price__regular .price-item--regular").text(total_amount_currency);
      }
    );    
  }

  function waitForDiscountPrice($activeProduct, callback, fallback) {
    // Already there (server-rendered member price): write now, not 200 ms later (task 140580)
    const $ready = $activeProduct.find('.af-price .af-discount-price');
    if ($ready.length) {
      callback($ready);
      return;
    }
    let checks = 0;
    const maxChecks = 15; // 15 * 200ms = 3 seconds
    const checkInterval = setInterval(() => {
      checks++;
      const $discount = $activeProduct.find('.af-price .af-discount-price');
      if ($discount.length) {
        clearInterval(checkInterval);
        callback($discount);
      } else if (checks >= maxChecks) {
        clearInterval(checkInterval);
        if (typeof fallback === "function") fallback();
      }
    }, 200);

    // stop checking after 3 seconds just in case
    setTimeout(() => clearInterval(checkInterval), 3000);
  }
  
  function renderTshirtPreview({
    canvasId,
    imageUrl,
    playerName,
    playerNumber,
    injectIntoSelector = null,
    options = {}
  })
  { 

    //console.log(canvasId,imageUrl,playerName,playerNumber,injectIntoSelector);
      
    const canvas = document.getElementById(canvasId);
    const ctx = canvas.getContext('2d');

    const image = new Image();
    image.crossOrigin = "anonymous";
    image.src = imageUrl;

    image.onload = () => {
      // ✅ Pick print font from the product's data-print-font (set in Liquid from the SKU tag). Fallback: Outlast
      const printFontWrapper = canvas.closest('[data-print-font]');
      const printFont = (options.printFont
        || (printFontWrapper && printFontWrapper.getAttribute('data-print-font'))
        || 'Outlast').trim();

      // Ensure the custom font is loaded before drawing to the canvas, otherwise
      // the browser silently falls back to a default font on first render.
      const draw = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

        const topPadding = 370;
        const vw = window.innerWidth / 100;
        const NumberfontSize = 9 * vw;
        const NamefontSize = 1.4 * vw;

        // ✅ Pick text color based on the trikot wrapper class the canvas sits in
        const trikotColorMap = {
          trikot_white:  '#ffffff', // dark green text on white shirt
          trikot_green:  '#007c3e',    // white text on green shirt
          trikot_orange: '#fb843f',    // white text on orange shirt
          trikot_black:  '#000000'     // white text on black shirt
        };

        let defaultTextColor = '#007c3e'; // fallback
        const wrapper = canvas.closest('.' + Object.keys(trikotColorMap).join(', .'));
        if (wrapper) {
          const matchedClass = Object.keys(trikotColorMap)
            .find(cls => wrapper.classList.contains(cls));
          if (matchedClass) defaultTextColor = trikotColorMap[matchedClass];
        }

        const textColor = options.textColor || defaultTextColor;

        // Text settings
        ctx.fillStyle = textColor;
        const centerX = canvas.width / 2;

        // Center on the glyph's actual ink, not its advance box. Display fonts give
        // narrow glyphs (1, 7) uneven side-bearing, so a plain textAlign="center"
        // leaves single digits looking off-centre while wide ones (19, 35) look fine.
        // Drawing left-aligned and offsetting by the ink midpoint centres every glyph.
        const drawInkCentered = (text, x, y) => {
          ctx.textAlign = "left";
          const m = ctx.measureText(text);
          // With textAlign "left" the pen sits at the origin; ink spans from
          // (origin - actualBoundingBoxLeft) to (origin + actualBoundingBoxRight).
          // Ink centre relative to the origin is (right - left) / 2, so shift the
          // origin left by that amount to land the ink centre exactly on x.
          const inkCentreFromOrigin = (m.actualBoundingBoxRight - m.actualBoundingBoxLeft) / 2;
          ctx.fillText(text, x - inkCentreFromOrigin, y);
        };

        // ✅ Optional manual nudge; defaults to 0 so the number stays ink-centred.
        const numberOffsetX = options.numberOffsetX !== undefined
          ? options.numberOffsetX
          : 0;

        // Number styling and placement
        ctx.font = `220px "${printFont}"`;
        drawInkCentered(String(playerNumber), centerX + numberOffsetX, topPadding);

        // Name styling and placement
        ctx.font = `30px "${printFont}"`;
        const nameTop = topPadding + 50; // Add good spacing below number
        drawInkCentered(playerName.toUpperCase(), centerX, nameTop);

        if (injectIntoSelector) {
          const imgData = canvas.toDataURL("image/png");
          $(injectIntoSelector).attr('src', imgData);
          $(injectIntoSelector).parent('a[data-fancybox="gallery"]').attr('data-src',imgData);
        }
      };

      console.log('printFont', printFont);

      if (document.fonts && typeof document.fonts.load === 'function') {
        Promise.all([
          document.fonts.load(`bold 220px "${printFont}"`),
          document.fonts.load(`normal 30px "${printFont}"`)
        ]).then(draw).catch(draw);
      } else {
        draw();
      }
    };
  }

  $(document).on('click','.active-product .individual_options .individuell-nummer-text',function(){
    const $activeProduct = $(this).closest(".active-product");
    $activeProduct.find('.individual_options .individual_list').slideDown();
    $activeProduct.find('.individual_options .individual_list').addClass('open-dropdown');
  });

  $(document).on('click','.active-product .individual_options .individual_list li',function(){
    const $activeProduct = $(this).closest(".active-product");
    let num_val = $(this).find('span').text();
    let num_sku = $(this).data('variant_sku');
    let variant_id =  $(this).data('variantid');
    $activeProduct.find('.individual_options .individual_list li').removeClass('active');
    $(this).addClass('active');
    $activeProduct.find('.individual_options .individuell-nummer-text').val(num_val);
    $activeProduct.find('.individual_options .individual_list').slideUp();
    $activeProduct.find('.individual_options .individual_list').removeClass('open-dropdown');    
  });

  $(document).on('click','.individual_options .close_icon',function(){
    const $activeProduct = $(this).closest(".active-product");
    $activeProduct.find('.individual_options .individual_list li').removeClass('active');
    $activeProduct.find('.individual_options .individuell-nummer-text').val('');
    $activeProduct.find('.individual_options .individual_list').slideUp();
    $activeProduct.find('.individual_options .individual_list').removeClass('open-dropdown');
  });

  initVerbandCupBatchAutoSelect();

});